import React from 'react';

export default function Heading2(props: React.PropsWithChildren) {
  return (
    <h2 className="heading heading--black heading--medium heading--centered text-3xl font-bold mb-4 text-center">
      {props.children}
    </h2>
  );
}
